import type { FaireProductEntity } from "../../entity_types/product";

export const p_6v7dxsr9e6: FaireProductEntity = {
  token: "p_6v7dxsr9e6",
  type: "product",
  name: "Circle Evil Eye Coin Purse",
  brandToken: "b_4ahkhhvtpz",
  brandName: "Collections by Fame Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/62322c2098c8409aeed6ccfaa89dac48133a12ea2c37888490c594786c31bf51.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/be4b933e87ac669d281ed947a39e9f88242e0f6545231e704f0716f739fa5d3d.jpeg",
    "https://cdn.faire.com/fastly/78544d838c7e271e87d19f3afa96ac56c7de01e6155c751228772530a723b6fd.jpeg",
  ],
  priceDollars: 10.05,
  description:
    "This coin purse brings a stunning circle evil eye style. Experience the joy of accessorizing with this piece that effortlessly combines versatility and charm.\r\n\r\nThis coin purse approximately measures (Inches):\r\nL: 5\r\nH: 4\r\n\r\nMADE IN CHINA\r\n\r\n60% BEADS\r\n40% POLYESTER",
  tags: [],
  msrpDollars: 34.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:26.970Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
